import { Stack, Typography } from '@mui/material';
import { colorGreenBase, colorRedBase } from '../../../constants';
import { East, NorthEast, SouthEast } from '@mui/icons-material';
import { FC } from 'react';
import './CompareBox.scss';

interface ComapareBoxProps {
  title: string;
  value: number | string;
  diffFormatted: string;
  diffValue: number;
  label: string;
  color: string;
}

const ComapareBox: FC<ComapareBoxProps> = ({
  title,
  value,
  diffFormatted,
  diffValue,
  label,
  color,
}) => {
  return (
    <Stack mb={2} direction={'row'} alignItems={'end'}>
      <Stack flex={1}>
        <Typography variant="h2" className="compare-box__title">
          {value}
        </Typography>
        <Typography variant="body2" className="compare-box__label">
          {title}
        </Typography>
      </Stack>
      <Stack flex={1}>
        <Stack flex={1} alignItems="flex-start">
          <Typography className="compare-box__diff" variant="body1" sx={{ color: color }}>
            {diffValue > 0 ? (
              <NorthEast className="compare-box__diff__icon" />
            ) : diffValue < 0 ? (
              <SouthEast className="compare-box__diff__icon" />
            ) : (
              <>-</>
            )}
            {diffFormatted}
          </Typography>
          <Typography className="compare-box__label" variant="body2">
            {label}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ComapareBox;
